

exports.__esModule = true;
exports.$InvalidAddressRoute = undefined;

require('./directive');

var _squid = require('squid');

var $InvalidAddressRoute = exports.$InvalidAddressRoute = _squid.$ComponentRoute.extend('$InvalidAddressRoute', {

    path: 'invalidAddressError',
    directive: 'xo-invalid-address-error',
    titleContent: 'shippingAddress.errorInfo',
    query: ['name', 'data'],
    // need to find these values
    trackingData: {
        fptiState: 'fatal_error',
        templateName: 'genericError.dust',
        pageGoal: 'Generic Error',
        pageQualifier: 'blockNonDomesticShipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-generic-error',
                'pagename2': '%::fullpage-generic-error:member:hermes:',
                'version': 'member:%:'
            }
        }
    },

    auth: false,

    children: []
});

angular.value("$InvalidAddressRoute", $InvalidAddressRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-error/xo-invalid-address-error/route.js
// module id = ./pages/xo-error/xo-invalid-address-error/route.js
// module chunks = 0